<template>
  <div>
    <button type="button" class="icon-btn" title="Add slider" @click="$bvModal.show(modalId)">
      <feather type="plus" size="16"></feather>
    </button>
    <b-modal
      size="xl"
      :id="modalId"
      title="Slider Add"
      @show="OnShowModal"
      ok-title="Save"
      @hide="clear"
      hide-footer
      ok-variant="primary"
      no-close-on-esc no-close-on-backdrop> 
      <div class="card">
        <div class="card-body">
            <div class="digital-add needs-validation">
              <div class="form-group">
                <label class="col-form-label pt-0">Upload <span>*</span></label>
                <vue-dropzone
                  id="AddSlider"
                  :options="AddSliderOptions"
                  class="dropzone digits"
                  ref="AddSlider"
                  :useCustomSlot="true"
                  v-on:vdropzone-success="uploadSuccess"
                  v-on:vdropzone-removed-file="fileRemoved"
                  @vdropzone-complete="uploadComplete"
                  @vdropzone-sending="sending" @vdropzone-error="uploadError"
                >
                </vue-dropzone>
              </div>
              <div class="row product-adding">
                <div class="col-xl-6">
                  <div class="form-group">
                    <label
                      for="validationtitle"
                      class="col-form-label pt-0"
                      >Title</label
                    >
                      <!-- Cadre couleur à droite du champ : ouvre la palette -->
                      <div class="slider-color-input">
                        <input
                          class="form-control"
                          id="validationtitle"
                          type="text"
                          v-model="title"
                        />
                        <input type="color" v-model="titlecolor" title="Title color" />
                      </div>
                  </div>
                  <div class="form-group">
                    <label
                      for="validationssubtitle"
                      class="col-form-label pt-0"
                      >Sub Title</label
                    >
                      <div class="slider-color-input">
                        <input
                          class="form-control"
                          id="validationssubtitle"
                          type="text"
                          v-model="subtitle"
                        />
                        <input type="color" v-model="subtitlecolor" title="Sub title color" />
                      </div>
                  </div>
                 <div class="form-group">
                    <label
                      for="validationoffer"
                      class="col-form-label pt-0"
                      >offer</label
                    >
                      <div class="slider-color-input">
                        <input
                          class="form-control"
                          id="validationoffer"
                          type="text"
                          v-model="offer"
                        />
                        <input type="color" v-model="offercolor" title="Offer color" />
                      </div>
                  </div>
              </div>
              <div class="col-xl-6">
                <div class="form-group">
                  <label
                    for="validationlink"
                    class="col-form-label pt-0"
                    >Link</label
                  >
                  <input
                    class="form-control"
                    id="validationlink"
                    type="text"
                    v-model="link"
                  />
                </div>
                <div class="form-group">
                  <label class="col-form-label"
                    >Align</label
                  >
                  <select class="custom-select" v-model="align">
                    <option value="p-left">Left</option>
                    <option value="p-center">Center</option>
                    <option value="p-right">Right</option>
                  </select>
                </div>
                <div class="form-group">
                  <label class="col-form-label"
                    >Status</label
                  >
                  <div
                    class="m-checkbox-inline mb-0 custom-radio-ml d-flex radio-animated"
                  >
                    <label class="d-block" for="edo-ani">
                      <input
                        class="radio_animated"
                        id="edo-ani"
                        type="radio"
                        name="rdo-ani"
                        v-model="status"
                        :value="true"
                      />
                      Enable
                    </label>
                    <label class="d-block" for="edo-ani1">
                      <input
                        class="radio_animated"
                        id="edo-ani1"
                        type="radio"
                        name="rdo-ani"
                        v-model="status"
                        :value="false"
                      />
                      Disable
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
            <!-- form end working -->
        </div>
      </div>
     <div class="col-xl-12 pb-3">
        <div class="form-group mb-0">
          <div class="product-buttons text-right">
            <button type="button" class="btn btn-light mr-2" @click="back">
              Cancel
            </button>
            <button type="button" class="btn btn-primary" @click="save">
              Save
            </button> 
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import firebase from '@/utils/firestore-shim';
import { uploadUrl, uploadHeaders, reportUploadError } from './../../../utils/imageUpload';
export default {
  // Deux boutons « + » peuvent coexister sur la page (en-tête du tableau
  // sur ordinateur, au-dessus du tableau sur mobile) : chacun a son propre
  // modal grâce à cet identifiant.
  props: {
    host: String,
    modalId: {
      type: String,
      default: "modal-SliderAdd"
    }
  },
  name: "sliderModalAdd",
  data() {
    return {
      title: "",
      image: "",
      subtitle:"",
      offer:"",
      link:"",
      // Couleurs des textes du slider : le panneau de la vitrine est
      // sombre, donc blanc par défaut.
      titlecolor: "#ffffff",
      subtitlecolor: "#ffffff",
      offercolor: "#ffffff",
      align:"p-left",
      status:true,
      AddSliderOptions: {
        url: uploadUrl,
        headers: uploadHeaders(),
        thumbnailWidth: 250,
        thumbnailHeight: 250,
        maxFiles: 1,
        maxfilesexceeded: function(file) {
            this.removeAllFiles();
            this.addFile(file);
          },
        accept: function(file, done) {
            done();
        },
        init: function() {
            this.on("removedfile", function(file) {
              return null;
            });
        },
        maxFilesize: 100,
        addRemoveLinks: true,
        uploadMultiple:false,
        maxThumbnailFilesize:20,
        dictDefaultMessage:
          "<i class='icon-cloud-up'></i><h6>Drop files here or click to upload. 150 x 50 px</h6><</span>",
      },
    };
  },
  methods: {
    save() {
      var formData = 
        {
          image: this.image,
          title: this.title,
          subtitle: this.subtitle,
          offer: this.offer,
          link: this.link,
          titlecolor: this.titlecolor,
          subtitlecolor: this.subtitlecolor,
          offercolor: this.offercolor,
          align: this.align,
          status: this.status
        }
      ;
      this.$emit("formData", formData);
      this.$bvModal.hide(this.modalId);
      //this.clear();
    },
    back(){
      this.$bvModal.hide(this.modalId);
    },
    OnShowModal(){
      this.clear();
    },
    uploadComplete(file, response){
      // L'API renvoie directement { url: '/uploads/...' } : l'image est
      // déjà stockée sur le serveur, plus besoin de renvoyer l'aperçu.
      try {
        var data = typeof response === 'string' ? JSON.parse(response) : (response || {});
        this.image = data.url;
      } catch (e) {
        reportUploadError(this, e.message);
      }
    },
    fileRemoved(){

    },
    uploadSuccess(){

    },
    clear(){
      this.title= "";
      this.image= "";
      this.subtitle="";
      this.offer="";
      this.link="";
      this.titlecolor="#ffffff";
      this.subtitlecolor="#ffffff";
      this.offercolor="#ffffff";
      this.align="p-left";
      this.status=true;
    },
    uploadError(file, message) {
      reportUploadError(this, message);
    },
    sending(file, xhr, formData) {
      // Juste avant l'envoi : indique à l'API le dossier de stockage.
      formData.append('folder', 'sites/' + this.host + '/sliders');
    }
  }
};
</script>

<style lang="scss" scoped>
/* Cadre couleur à droite de chaque champ texte : cadre cliquable qui
   ouvre la palette de couleurs du navigateur */
.slider-color-input {
    display: flex;
    align-items: center;

    .form-control {
        flex: 1 1 auto;
        min-width: 0;
    }

    input[type="color"] {
        flex-shrink: 0;
        width: 3.25rem;
        height: 2.38rem;
        margin-left: 0.5rem;
        padding: 0.15rem;
        border: 1px solid #e6e2e6;
        border-radius: 0.25rem;
        background-color: #fff;
        cursor: pointer;
    }
}
</style>